export const getDateObjectFromISOString = (dateISOString: string) => {
  const dateObject = new Date(dateISOString);

  if (isNaN(dateObject.getTime())) {
    throw new Error('Invalid ISO String');
  }

  return dateObject;
};
